import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import styled from '@mui/material/styles/styled';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import React from 'react';

import CustomButtonGroup from '../../components/CustomButtonGroup/CustomButtonGroup';
import CustomDrawer from '../../components/CustomDrawer/CustomDrawer';

const StyledTableHeadCell = styled(TableHead)(({theme, filterable}) => ({
  color: theme.palette.primary.dark2,
  backgroundColor: theme.palette.primary.medium2,
  '& th': {
    fontWeight: 'bold',
  },
}));

const UpdateOutletConfirmationDrawer = ({
  open,
  onToggleOff,
  selectedRow,
  formData,
  dataToUpdate,
  handleOnUpdate,
  ancillaryColumns,
  formAncillaryData,
  dataQueryAncillary,
  ancillaryDataToUpdate,
  ancillaryDataToInsert,
}) => {
  return (
    <CustomDrawer open={open} onToggleOff={onToggleOff} anchor={'right'} title={'Verify Changes'} actionButtons={false}>
      <Box sx={{p: 2}}>
        <TableContainer component={Paper}>
          <Table>
            <StyledTableHeadCell>
              <TableRow>
                <TableCell>Field</TableCell>
                <TableCell>Previous Value</TableCell>
                <TableCell>Current Value</TableCell>
              </TableRow>
            </StyledTableHeadCell>
            <TableBody>
              {Object.keys(dataToUpdate).map((key, index) => {
                let previousValue = selectedRow?.row?.[key];
                if (key === 'channel') {
                  previousValue =
                    selectedRow?.row?.channelGroupName === selectedRow?.row?.channelName
                      ? `${selectedRow?.row?.channelName}-direct`
                      : `${selectedRow?.row?.channelGroupName}-${selectedRow?.row?.channelName}`;
                }
                return (
                  <TableRow key={index}>
                    <TableCell>{formData[key]?.label}</TableCell>
                    <TableCell>{previousValue}</TableCell>
                    <TableCell>{dataToUpdate[key]}</TableCell>
                  </TableRow>
                );
              })}
              {ancillaryDataToUpdate.map((data, index) => {
                const existingValue = dataQueryAncillary?.data?.rows?.find((d) => d.id === data.id);
                const currentValue = formAncillaryData[index];
                return (
                  <React.Fragment key={index}>
                    {Object.keys(data).map(
                      (key, innerIndex) =>
                        ancillaryColumns.includes(key) && (
                          <TableRow key={innerIndex}>
                            <TableCell>{`[${data?.index}].${currentValue[key]?.label}`}</TableCell>
                            <TableCell>{existingValue?.[key]}</TableCell>
                            <TableCell>{data?.[key]}</TableCell>
                          </TableRow>
                        )
                    )}
                  </React.Fragment>
                );
              })}
              {ancillaryDataToInsert.map((data, index) => {
                const currentValue = formAncillaryData[index];
                return (
                  <React.Fragment key={index}>
                    {Object.keys(data).map(
                      (key, innerIndex) =>
                        ancillaryColumns.includes(key) && (
                          <TableRow key={innerIndex}>
                            <TableCell>{`[${data?.index}].${currentValue[key]?.label}`}</TableCell>
                            <TableCell></TableCell>
                            <TableCell>{data?.[key]}</TableCell>
                          </TableRow>
                        )
                    )}
                  </React.Fragment>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
        <Box sx={{mt: 5, display: 'flex', justifyContent: 'end'}}>
          <CustomButtonGroup
            first={{
              text: 'Back',
              color: 'primary',
              variant: 'outlined',
              onClick: onToggleOff,
              size: 'medium',
            }}
            second={{
              text: 'Update',
              color: 'secondary',
              className: 'color-secondary',
              variant: 'contained',
              size: 'medium',
              onClick: handleOnUpdate,
            }}
          />
        </Box>
      </Box>
    </CustomDrawer>
  );
};

export default UpdateOutletConfirmationDrawer;
